import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const STATUS_STYLES = {
  new: { label: "New", bg: "bg-[#002FA7]/10", text: "text-[#002FA7]", dot: "bg-[#002FA7]" },
  contacted: { label: "Contacted", bg: "bg-amber-50", text: "text-amber-700", dot: "bg-amber-500" },
  in_progress: { label: "In Progress", bg: "bg-sky-50", text: "text-sky-700", dot: "bg-sky-500" },
  qualified: { label: "Qualified", bg: "bg-indigo-50", text: "text-indigo-700", dot: "bg-indigo-500" },
  won: { label: "Won", bg: "bg-emerald-50", text: "text-emerald-700", dot: "bg-emerald-600" },
  lost: { label: "Lost", bg: "bg-rose-50", text: "text-rose-700", dot: "bg-rose-600" },
};

export const STATUSES = ["new", "contacted", "in_progress", "qualified", "won", "lost"];

export function formatDate(iso, opts = {}) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleString("en-ZA", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: opts.time === false ? undefined : "2-digit",
      minute: opts.time === false ? undefined : "2-digit",
    });
  } catch {
    return iso;
  }
}

export function relativeTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
  return formatDate(iso, { time: false });
}
